import { Certificate } from 'types/Certificate';

export const filterEmptyCertificates = (certificates: Certificate[]): Certificate[] =>
  certificates.filter((cert) => Object.values(cert).some((val) => !!val));
